import { postJSON } from 'common/services/api'
import { useMutation, useQueryClient } from 'react-query'
import {
  MAR_CHART_QUERY_KEY,
  MEDICATION_SCHEDULE_PATTERN_QUERY_KEY,
  MEDICATION_SCHEDULE_PATTERN_UNPAUSE_URL,
  MEDICATION_SCHEDULE_PATTERNS_QUERY_KEY,
  STOCK_LOGS_QUERY_KEY
} from './queryConstants'

type UseMedicationSchedulePatternUnpauseReturn = {
  unpauseMedicationSchedulePattern: (reason: string) => Promise<void>
  isUnpausingMedicationSchedulePattern: boolean
}

export type UseMedicationSchedulePatternUnpauseProps = {
  medicationId: string
  onSuccess?: () => void
  onError?: () => void
}

const useMedicationSchedulePatternUnpause = ({
  medicationId,
  onSuccess,
  onError
}: UseMedicationSchedulePatternUnpauseProps): UseMedicationSchedulePatternUnpauseReturn => {
  const queryClient = useQueryClient()

  const unpauseMedicationSchedulePatternFunction = async (
    reason: string
  ): Promise<unknown> => {
    return postJSON({
      url: MEDICATION_SCHEDULE_PATTERN_UNPAUSE_URL.replace(
        '{id}',
        medicationId
      ),
      method: 'PUT',
      json: {
        reason
      }
    })
  }

  const {
    mutateAsync: unpauseMedicationSchedulePatternMutation,
    isLoading: isUnpausingMedicationSchedulePattern
  } = useMutation<unknown, unknown, string, unknown>(
    [MEDICATION_SCHEDULE_PATTERN_QUERY_KEY],
    unpauseMedicationSchedulePatternFunction,
    {
      onSuccess: () => {
        queryClient.invalidateQueries([MEDICATION_SCHEDULE_PATTERNS_QUERY_KEY])
        queryClient.invalidateQueries([MEDICATION_SCHEDULE_PATTERN_QUERY_KEY])
        queryClient.invalidateQueries([MAR_CHART_QUERY_KEY])
        queryClient.invalidateQueries([STOCK_LOGS_QUERY_KEY])
        onSuccess?.()
      },
      onError: () => {
        onError?.()
      }
    }
  )

  const unpauseMedicationSchedulePattern = async (
    reason: string
  ): Promise<void> => {
    await unpauseMedicationSchedulePatternMutation(reason)
  }

  return {
    unpauseMedicationSchedulePattern,
    isUnpausingMedicationSchedulePattern
  }
}

export default useMedicationSchedulePatternUnpause
